module.exports = __webpack_public_path__ + "img/icon-wdzx.a76dfd3a.png";